export const POS_V2_MODES = [
  { id: 'vente', label: 'Vente' },
  { id: 'client', label: 'Client' },
  { id: 'reparation', label: 'Réparation' },
  { id: 'acompte', label: 'Acompte' },
  { id: 'hors_stock', label: 'Hors stock' },
  { id: 'commandes', label: 'Commandes' },
];

export const SESSION_KEY = 'pos_session_magasin_id';
export const LEGACY_KEY = 'pos_current_magasin_id';
export const POS_V2_DEFAULT_KEY = 'pos_v2_preferred';

export const readSessionMag = (fallback) => {
  try {
    const v = window.localStorage.getItem(SESSION_KEY) || window.localStorage.getItem(LEGACY_KEY);
    return (v && v.trim()) || fallback || 'M1';
  } catch {
    return fallback || 'M1';
  }
};

export const fmt = (n) => Number(n || 0).toFixed(2);

/** Prix catalogue POS V2 — promo manuelle ou calendrier/journalière. */
export const resolvePosCatalogPrice = (item) => {
  const base = Number(item?.prix_vente_base ?? item?.prix_vente ?? 0);
  const hasPromo = Boolean(item?.has_promo);
  const eff = hasPromo && item?.prix_vente_effectif != null
    ? Number(item.prix_vente_effectif)
    : base;
  return {
    eff,
    base,
    hasPromo: hasPromo && eff < base - 0.001,
    promo: item?.active_promo || null,
  };
};
